function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1253.000000, -38.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1253.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,18 C4.03714286,18 0,13.9628571 0,9 C0,4.03714286 4.03714286,0 9,0 C13.9628571,0 18,4.03714286 18,9 C18,13.9628571 13.9628571,18 9,18 Z M9,2.18181818 C5.24045455,2.18181818 2.18181818,5.24045455 2.18181818,9 C2.18181818,12.7595455 5.24045455,15.8181818 9,15.8181818 C12.7595455,15.8181818 15.8181818,12.7595455 15.8181818,9 C15.8181818,5.24045455 12.7595455,2.18181818 9,2.18181818 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5365983,19.2594726 L14.3612518,14 C13.8978438,14.5816775 13.5964546,14.7907716 13,15.2426987 L18.1257045,20.598435 C18.3455696,20.812853 19.1034792,21.2999167 19.7422499,20.7403862 C20.205504,20.3345992 19.9875164,19.6939694 19.5365983,19.2594726 Z"
}))))));
var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search.4cc78734.svg";
export { ForwardRef as ReactComponent };